module.exports = __webpack_public_path__ + "static/media/transport2.949a3b3c.jpeg";